/**
 * When the browser still reports "online" but requests fail, show the same
 * offline-style banner after this many consecutive `network.request.failed`
 * events. Requirement: show only when count is **greater than** this value
 * (e.g. threshold 5 → banner at the 6th failure).
 */
export const SEQUENTIAL_NETWORK_FAILURE_OFFLINE_THRESHOLD = 5;
